<template>
  <modal-v2
    ref="modal"
    size="medium"
    title="Configurações de impressão"
    icon="print-outline"
    auto-body-height
    unlock-body-overflow
  >
    <template #body>
      <p class="mb-4">
        Você pode saber mais e modificar suas preferências em
        <a :href="configurationsUrl" target="_blank" rel="noreferer noopener">configurações</a>.
      </p>

      <mui-list
        :gap="2"
        orientation="column"
        fluid-items
      >
        <card-button
          v-for="option in options"
          :key="option.value"
          v-bind="option"
          :selected="getSelected(option.value)"
          @click.native="handleOption(option.value)"
        />
      </mui-list>
    </template>

    <template #footer>
      <mui-switch v-model="save" label="Salvar preferências e não exibir novamente" />

      <div class="ml-auto">
        <button
          class="mui-button mui-button--minimal"
          @click="close"
        >
          Cancelar
        </button>

        <button
          class="mui-button mui-button--primary"
          :disabled="!quality"
          @click="confirm"
        >
          Avançar
        </button>
      </div>
    </template>
  </modal-v2>
</template>

<script>
import ModalV2 from 'commons/js/components/atoms/ModalV2';
import MuiList from "commons/js/components/organisms/MUIList";
import CardButton from 'commons/js/components/atoms/CardButton';
import MuiSwitch from "commons/js/components/atoms/MUISwitch";

import { PRINT_QUALITIES } from "commons/js/config/print";

export default {
  components: {
    ModalV2,
    MuiList,
    CardButton,
    MuiSwitch,
  },

  props: ['order'],

  data() {
    return {
      options: [
        {
          value: PRINT_QUALITIES.DEFAULT,
          title: 'Qualidade padrão',
          text: 'Ideal para impressoras comuns',
          tag: 'Imprime em média 500 etiquetas',
        },
        {
          value: PRINT_QUALITIES.HIGH,
          title: 'Qualidade alta',
          text: 'Ideal para impressoras térmicas',
          tag: 'Imprime em média 100 etiquetas',
        },
      ],

      quality: MEConfig.get('preferences.print_quality'),

      save: false,

      configurationsUrl: MEConfig.get('dash.url') + '/configuracoes',
    };
  },

  methods: {
    handleOption(value) {
      this.quality = value;
    },

    getSelected(value) {
      return this.quality === value;
    },

    open() {
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },

    updatePreferences(preferences) {
      return axios.put('/api/v2/me/preferences', preferences);
    },

    updatePrintPreferences() {
      this.updatePreferences({
        'print_quality': this.quality,
        'print_preferences_alert': (new Date()).toISOString(),
      });
    },

    confirm() {
      this.$emit('confirm', this.order, this.quality);

      if (this.save) this.updatePrintPreferences();
    },
  },
};
</script>
